export default "__VITE_ASSET__nPNXQ$yQ__"